<template>
  <div>
    <div
      v-for="(setParams, setIndex) in sets"
      :key="'set'+setIndex"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block"
        style="width: 50px"
        :class="{ 'caption': dense, 'text-body-1': !dense }"
      >
        {{ $t("training_builder.configure.set", {set: setIndex + 1}) }}:
      </div>

      <exercise-param-label-helper
        :label="$t('reps.label')"
        :dense="dense"
        :param="setParams.NMRP"
      />

      <exercise-param-label-helper
        :label="$t('event_type.rest')"
        :dense="dense"
        :param="setParams.RSSTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.distance.title') + ' 1'"
        :dense="dense"
        :param="setParams.DIST1"
        suffix="m"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.configure.prescriptor.duration') + ' 1'"
        :dense="dense"
        :param="setParams.DR1"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.groups.speed') + ' 1'"
        :dense="dense"
        :param="setParams.SPD1"
        :suffix="$t('suffixes.km/h')"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.incline.title') + ' 1'"
        :dense="dense"
        :param="setParams.INCL1"
        suffix="%"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.intensity.title') + ' 1'"
        :dense="dense"
        :param="setParams.INTS1"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.floors.title') + ' 1'"
        :dense="dense"
        :param="setParams.NOFL1"
        suffix="%"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.500m_pace.title') + ' 1'"
        :dense="dense"
        :param="setParams.FIVPC1"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.rpm.title') + ' 1'"
        :dense="dense"
        :param="setParams.RPM1"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.watts.title') + ' 1'"
        :dense="dense"
        :param="setParams.WAT1"
        suffix="W"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.distance.title') + ' 2'"
        :dense="dense"
        :param="setParams.DIST2"
        suffix="m"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.configure.prescriptor.duration') + ' 2'"
        :dense="dense"
        :param="setParams.DR2"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.groups.speed') + ' 2'"
        :dense="dense"
        :param="setParams.SPD2"
        :suffix="$t('suffixes.km/h')"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.incline.title') + ' 2'"
        :dense="dense"
        :param="setParams.INCL2"
        suffix="%"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.intensity.title') + ' 2'"
        :dense="dense"
        :param="setParams.INTS2"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.floors.title') + ' 2'"
        :dense="dense"
        :param="setParams.NOFL2"
        suffix="%"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.500m_pace.title') + ' 2'"
        :dense="dense"
        :param="setParams.FIVPC2"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.rpm.title') + ' 2'"
        :dense="dense"
        :param="setParams.RPM2"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.watts.title') + ' 2'"
        :dense="dense"
        :param="setParams.WAT2"
        suffix="W"
      />
    </div>
  </div>
</template>
<script>

import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'

export default {
  name: 'CardioParamsView',
  components: { ExerciseParamLabelHelper },
  props: {
    sets: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  }
}
</script>
